export default __webpack_public_path__ + "static/media/Medal.3abd1695.svg";